import { render, staticRenderFns } from "./licenseDetail.vue?vue&type=template&id=157279b2&scoped=true"
import script from "./licenseDetail.vue?vue&type=script&lang=js"
export * from "./licenseDetail.vue?vue&type=script&lang=js"
import style0 from "./licenseDetail.vue?vue&type=style&index=0&id=157279b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157279b2",
  null
  
)

export default component.exports